import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import type { Customer, PartialUpdateCustomer } from '@/types/customer'

export async function updateCustomer(
  id: string,
  customer: PartialUpdateCustomer
): Promise<Customer> {
  return await makePatchRequest(ApiBase + `/customers/${id}`, {
    body: customer,
  })
}
